var _dec, _dec2, _dec3, _dec4, _class;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { inject, injectable } from 'inversify';
import TYPES from 'di/types';
import { Subject } from 'rxjs/internal/Subject';
import { UserExternalAppType } from 'moduleUser/constants/UserExternalAppType';
import { setMomentTimezone } from 'srcJs/components/moment';
var User = (_dec = injectable(), _dec2 = function _dec2(target, key) {
  return inject(TYPES.UserSource)(target, undefined, 0);
}, _dec3 = Reflect.metadata("design:type", Function), _dec4 = Reflect.metadata("design:paramtypes", [void 0]), _dec(_class = _dec2(_class = _dec3(_class = _dec4(_class = /*#__PURE__*/function () {
  function User(userSource) {
    _classCallCheck(this, User);

    _defineProperty(this, "subject", new Subject());

    this.source = userSource;
  }

  _createClass(User, [{
    key: "onChange",
    value: function onChange(callback) {
      return this.subject.subscribe(callback);
    }
  }, {
    key: "getData",
    value: function getData() {
      return this.source.get();
    }
  }, {
    key: "setData",
    value: function setData(userData) {
      this.source.set(userData);
      setMomentTimezone(userData.timezone, userData.timezoneAlias, userData.timezoneServer);
      this.subject.next(userData);
    }
  }, {
    key: "getId",
    value: function getId() {
      return this.getData().id;
    }
  }, {
    key: "getAvatarImage",
    value: function getAvatarImage() {
      return this.getData().avatar.image;
    }
  }, {
    key: "setAvatarImage",
    value: function setAvatarImage(avatar) {
      var data = this.getData();
      data.avatar.image = avatar;
      this.setData(data);
    }
  }, {
    key: "getFullName",
    value: function getFullName() {
      return this.getData().fullName;
    }
  }, {
    key: "getEmail",
    value: function getEmail() {
      return this.getData().email;
    }
  }, {
    key: "getBalance",
    value: function getBalance() {
      return this.getData().balance;
    }
  }, {
    key: "setBalance",
    value: function setBalance(balance) {
      var data = this.getData();

      var dataNew = _objectSpread(_objectSpread({}, data), {}, {
        balance: balance
      });

      this.setData(dataNew);
    }
  }, {
    key: "getCurrency",
    value: function getCurrency() {
      return this.getData().currency;
    }
  }, {
    key: "isOwner",
    value: function isOwner() {
      return this.getData().isOwner;
    }
  }, {
    key: "isCustomer",
    value: function isCustomer() {
      return this.getData().isCustomer;
    }
  }, {
    key: "isEmailConfirmed",
    value: function isEmailConfirmed() {
      return this.getData().emailConfirmed;
    }
  }, {
    key: "addExternalApp",
    value: function addExternalApp(type, externalAppData) {
      var data = _objectSpread({}, this.getData());

      data.linkedExternalApps[UserExternalAppType[type]] = {
        status: true,
        data: externalAppData
      };
      this.setData(data);
    }
  }, {
    key: "removeExternalApp",
    value: function removeExternalApp(type) {
      var data = _objectSpread({}, this.getData());

      var linkedExternalApp = data.linkedExternalApps[UserExternalAppType[type]];

      if (linkedExternalApp) {
        linkedExternalApp.status = false;
        data.linkedExternalApps[UserExternalAppType[type]] = linkedExternalApp;
      }

      this.setData(data);
    }
  }]);

  return User;
}()) || _class) || _class) || _class) || _class);
export default User;